export const cleanObject = (
  obj: any,
  excludedKeys: string[] = [],
  filterValue = [null, undefined],
) =>
  Object.keys(obj).reduce((acc, currentKey) => {
    // Validating if the key should be bypassed
    if (filterValue.includes(obj[currentKey]) && !excludedKeys.includes(currentKey)) {
      return {
        ...acc,
      };
    }
    // If the key was not bypassed it will be added to the output
    return {
      ...acc,
      [currentKey]: obj[currentKey],
    };
  }, {});
